import React, { Component, createRef } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import {  map, isEmpty, size } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Swal from 'sweetalert2'
import classnames from "classnames"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import deleteIcon from "../../assets/images/icons/bin.png";
import icon1  from "../../assets/img/message-icon.png";
import icon2 from "../../assets/img/documents-icon.png";
import icon3 from "../../assets/img/appointment-icon.png";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Collapse,
  CardHeader,
    Table
} from "reactstrap"
import { API_URL } from "helpers/api_url";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import RsLink from "components/Buttons/rsLink";
class SupportPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      services:[],
      industry : [],
      loading: true,
       selectedIndustries: [],
      contactFilter: ""
    }
     this.dt = createRef();
  }
   fetchIndustry() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
        const params = {
          agentId: localStorage.getItem("agentId"),
          clientId: localStorage.getItem("userId"),
        };
        axios
          .get(`${API_URL}ServiceType/allforagent`, { headers, params })
          .then((response) => {
            this.setState({ industry: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
  fetchProfessionalService() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
        const params = {
          agentId: localStorage.getItem("agentId"),
        };
        axios
          .get(`${API_URL}ProfessionalService/allagentprofessionalservices`, { headers, params })
          .then((response) => {
            this.setState({ services: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
       componentDidMount() {
            this.fetchIndustry();
            this.fetchProfessionalService();
        }
industryFilterTemplate = (options) => {
    const { industry } = this.state;
    return (
      <MultiSelect
        value={this.state.selectedIndustries}
        options={industry.map((i) => ({ label: i.serviceTypeTitle, value: i.id }))}
        onChange={(e) => {
          this.setState({ selectedIndustries: e.value });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Select Industries"
        className="p-column-filter"
      />
    );
  };

  // Custom filter template for Contact Name (InputText)
  contactFilterTemplate = (options) => {
    return (
      <InputText
        value={this.state.contactFilter}
        onChange={(e) => {
          this.setState({ contactFilter: e.target.value });
          options.filterCallback(e.target.value, options.index);
        }}
        placeholder="Search Contact"
        className="p-column-filter"
      />
    );
  };

  // Filter logic for Industry
  industryFilterFunction = (value, filter) => {
    if (!filter || filter.length === 0) return true;
    return filter.includes(value);
  };

  // Filter logic for Contact Name
  contactFilterFunction = (value, filter) => {
    if (!filter) return true;
    return value?.toLowerCase().includes(filter.toLowerCase());
  };
  render() {
    const { loading, services, industry } = this.state;
    return (
      <React.Fragment>
        {loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
       
        <div className="page-content">
          <MetaTags>
            <title>Seller Showings  | Realty Space</title>
          </MetaTags>
          <Container fluid>
             {/* <Breadcrumbs
              title={this.props.t("Seller")}
              breadcrumbItem={this.props.t("Seller Showings ")}
            /> */}
              <Row className="justify-content-between align-items-center mb-4">
                            <Col sm="12">
                              <Nav tabs className="projectTab pref-tab">
                                <NavItem>
                                  <Link className="nav-link active" to="/support">
                                    <span className="d-flex align-items-center gap-2">
                                      Professional Network
                                      <img src={icon1} height={16} />
                                    </span>
                                  </Link>
                                </NavItem>
                                <NavItem>
                                  <Link className="nav-link" to="/helpful-links">
                                    <span className="d-flex align-items-center gap-2">Helpful links
            
                                       <img src={icon2} height={16} />
                                    </span>
                                  </Link>
                                </NavItem>
                                <NavItem>
                                  <Link className="nav-link" to="/helpful-documents">
                                     <span className="d-flex align-items-center gap-2">Documents
            
                                      <img src={icon3} height={16} />
                                     </span>
                                  </Link>
                                </NavItem>
                              </Nav>
                            </Col>
                          </Row>
            <Row>
              
              
              <Col xl="12">
          
			  <Row>
				<Col sm="12">
					 <Card className="rs-card-bg"> 
                        <CardHeader>
                                <RsLink  iconClass="bx bx-reset" className="btn btn-outline-secondary float-end"  onClick={() => this.dt.current.reset()}>Reset all filters</RsLink>
                        </CardHeader>
                    <CardBody>
                    
				

          

                            <DataTable
                              className=""
                              ref={this.dt}
                              stripedRows
                              value={services}
                             
                              paginator
                              rows={10}
                              rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              tableStyle={{ minWidth: "50rem" }}
                            >
                              <Column
                                    field="serviceType"
                                    header="Industry"
                                    body={(rowData) =>
                                        industry.find((opt) => opt.id === rowData.serviceType)?.serviceTypeTitle || ""
                                    }
                                    filter
                                     showFilterMatchModes={false}  
                                    showFilterOperator={false}     
                                    showAddButton={false}       
                                    showClearButton={false}          
                                    filterMatchMode="in" 
                                    filterElement={this.industryFilterTemplate}
                                    filterFunction={this.industryFilterFunction}
                                    />
                               <Column
                                field="organizationName"
                                header="Business name"
                              />
                            <Column
                                field="contactName"
                                header="Contact"
                              />
                               <Column
                                field="primaryContact.mobile"
                                header="Mobile"
                              />
                               <Column
                                field="organizationWebsite"
                                header="Website"
                              />

                               <Column
                                field="primaryContact.email"
                                header="Email"
                              />
                               <Column
                                field="primaryContact.office"
                                header="Office"
                              />

                                    
                             
                            </DataTable>
					</CardBody>
					</Card>
				</Col>
			</Row>
			
			
            </Col>
            
            </Row>
           
          </Container>
         
        </div>
      </React.Fragment>
    )
  }
}
SupportPage.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object

}
const mapStateToProps = ({  }) => (
  {
     
   

  })
const mapDispatchToProps = dispatch => ({
 
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SupportPage))
